const tr: Record<string, string> = {
  'nav.blog': 'Blog',
  'nav.virtualOffice': 'Sanal Ofis',
  'nav.coworking': 'Coworking',
  'nav.accounting': 'Muhasebe & Hukuk',
  'nav.contact': 'İletişim',
  'nav.clientPortal': 'Müşteri Portalı',
  'nav.getStarted': 'Başlayın',
  'nav.menu': 'Gezinme menüsü',
  'hero.badge': '7 ülkeden 400+ şirketin güveni',
  'hero.title1': 'Belgrad\'da sanal ofis',
  'hero.title2': 'yabancı ve yerli şirketler için',
  'hero.title3': '',
  'hero.desc': 'Sırbistan\'da şirket kuruyor ya da taşıyorsunuz ve adresinizin mevzuata uygun olup APR\'de kabul edilip edilmeyeceğinden emin değil misiniz? Sırbistan yasalarına uygun, 100% legal bir iş adresi, şirket tescili ve idari destek alırsınız; imzadan sonra 48 saat içinde aktif.',
  'hero.trust1': 'Belgrad ve Kovin’de (Pančevo vergi dairesi) iş adresi; Loznica yakında, ilginizi iletin',
  'hero.trust2': 'Sırbistan\'da şirket açılışında yardım',
  'hero.trust3': 'Posta alımı ve iletimi',
  'hero.trust4': 'Muhasebe ve idari destek',
  'hero.cta1': 'Bugün Sırbistan\'da işe başlayın',
  'hero.cta2': 'Nasıl Çalışır',
  'hero.reviews': '180+ doğrulanmış müşteri yorumundan',
  'hero.clientPortal': 'Müşteri Portalı',
  'hero.active': 'Aktif',
  'hero.documents': 'Belgeler',
  'hero.invoices': 'Faturalar',
  'hero.plan': 'Plan',
  'hero.address': 'Adres',
  'hero.liveActivity': 'Canlı Aktivite',
  'hero.docUploaded': 'Yeni belge yüklendi',
  'hero.invoicePaid': 'Fatura ödendi',
  'hero.mailForwarded': 'Posta iletildi',
  'hero.newClients': '12 yeni müşteri',
  'hero.thisMonth': 'Bu ay',
  'hero.mockCompany': 'EVI Solutions DOO',
  'hero.activityCompany1': 'Tehno sistem d.o.o.',
  'hero.activityCompany2': 'Jadran ticaret d.o.o.',
  'hero.activityCompany3': 'Stojanović danışmanlık d.o.o.',
  'hero.timeAgo2m': '2 dk önce',
  'hero.timeAgo18m': '18 dk önce',
  'hero.timeAgo1h': '1 sa önce',
  'hero.kpi.documentsSub': 'bu hafta 2 yeni',
  'hero.kpi.invoicesSub': '1 ödeme bekliyor',
  'hero.kpi.planSub': 'Sanal ofis',
  'hero.kpi.addressValue': 'Belgrad',
  'hero.kpi.addressSub': 'Topčiderska 14',
  'services.tag': 'Ne Sunuyoruz',
  'services.title': 'İş adresi, posta kabulü ve\nmuhasebe tek bir yerde',
  'services.desc':
    'Yabancı şirketler ve yerel girişimciler için Top14 ofis çözümleri tescil, adres ve sürekli desteği kapsar.',
  'services.mostPopular': 'En Popüler',
  'services.virtualOffice.tag': 'İş Adresi & Tescil',
  'services.virtualOffice.title': 'Sanal Ofis',
  'services.virtualOffice.desc':
    'Belgrad (Topčiderska) ve Kovin (Pančevo vergi dairesi) kayıtlı iş adresleri. Loznica konumu yakında, ilginizi bildirin. Posta işleme, şirket tescil desteği ve güvenli belge portalı dahil.',
  'services.virtualOffice.taxNote':
    'İş modelinize bağlı olarak alternatif lokasyonlar vergi optimizasyonuna ek katkı sağlayabilir.',
  'services.virtualOffice.f1': 'Belgrad – Topčiderska, Savski venac belediyesi',
  'services.virtualOffice.f5': 'Kovin, Pančevo vergi dairesi - Sırbistan\'daki en uygun maktu vergi',
  'services.virtualOffice.f6': 'Loznica, yakında, BiH sınırına yakın (ilginizi iletin)',
  'services.virtualOffice.f2': 'APR tescil desteği',
  'services.virtualOffice.f3': 'Yabancı şirketler için uygun',
  'services.virtualOffice.f4': 'Belge yönetim portalı',
  'services.virtualOffice.price': '3.500 RSD',
  'services.virtualOffice.per': '/ ay (~30 EUR)',
  'services.virtualOffice.learn': 'Daha fazla bilgi',
  'services.coworking.tag': 'Esnek Çalışma Alanı',
  'services.coworking.title': 'Coworking Alanı',
  'services.coworking.desc': 'Belgrad merkezinde modern çalışma masaları ve özel ofisler. 1 Gbps gigabit internet, 3 toplantı odası ve en fazla 20 kullanıcılı sakin bir alan.',
  'services.coworking.price': '€89',
  'services.coworking.per': '/ ay',
  'services.coworking.plans': 'Planları görüntüle',
  'services.accounting.tag': 'İş Desteği',
  'services.accounting.title': 'Muhasebe & Hukuk',
  'services.accounting.desc': 'Muhasebe, KDV kaydı, vergi beyannameleri ve hukuki danışmanlık.',
  'services.accounting.cta': 'Ücretsiz danışmanlık',
  'capitaale.aria': 'Pauschal girişimciler için önerilen uygulama',
  'capitaale.tag': 'Pauschal girişimciler için önerilen',
  'capitaale.desc':
    'Capitaale, yurt dışından faturalandıran girişimciler için bir uygulamadır. Banka kuru sonrası gerçek RSD bakiyesi, canlı pausal limiti, tek bir müşteri gelirin %70\'ini geçtiğinde uyarı ve 60 saniyede EUR veya USD fatura. İlk 7 gün ücretsiz.',
  'capitaale.cta': '7 gün ücretsiz dene',
  'capitaale.external': 'Capitaale ortak sayfasını açar',
  'how.tag': 'Adım adım',
  'how.title': 'Sırbistan\'da bizimle işinizi nasıl başlatırsınız',
  'how.desc':
    'İlk fikirden tam operasyonel şirkete kadar tüm süreçte yanınızdayız; karmaşa ve zaman kaybı olmadan.',
  'how.step1.title': 'Kısa danışma görüşmesi',
  'how.step1.lead': 'İhtiyaçlarınızı anlarız ve en iyi çözümü öneririz',
  'how.step1.desc':
    'Sırbistan\'daki faaliyetiniz, hedefleriniz ve kapsamınız hakkında konuşuruz; ardından optimal hizmet paketini öneririz.',
  'how.step1.badge': '15–30 dk',
  'how.step2.title': 'İşbirliği teklifi ve sözleşme',
  'how.step2.lead': 'Net bir plan ve tüm koşulları önceden alırsınız',
  'how.step2.desc':
    'Somut bir hizmet teklifi ve örnek sözleşme göndeririz. Her şey şeffaftır; gizli maliyet yoktur.',
  'how.step2.check1': 'net tanımlı',
  'how.step2.check2': 'minimum bürokrasi',
  'how.step3.title': 'İş adresi izni',
  'how.step3.lead': 'Adresimizi kayıtlı merkez olarak kullanmanız için izin alırsınız',
  'how.step3.intro': 'Bizden aldığınız:',
  'how.step3.bullet1': 'adresimizin APR\'de tescili için izin',
  'how.step3.bullet2': 'merkez adresi için gerekli belgeler',
  'how.step3.bullet3': 'bu adreste posta kabulü',
  'how.step3.badge': 'genelde birkaç gün',
  'how.step4.title': 'Aktivasyon ve portal üzerinden çalışma',
  'how.step4.lead': 'Gerisi tek yerden yönetilir',
  'how.step4.desc': 'İmzadan sonra portalımızda hesabınızı açarız; burada:',
  'how.step4.bullet1': 'belgeleri yönetirsiniz',
  'how.step4.bullet2': 'ekiple iletişim kurarsınız',
  'how.step4.bullet3': 'faturaları ve hizmetleri takip edersiniz',
  'how.step4.badge': '7/24 destek',
  'how.cta': 'Karmaşa olmadan işe başlayın',
  'how.learnMore': 'Daha Fazla Bilgi',
  'vo.tag': 'Sanal Ofis',
  'vo.title': 'İşletmeniz İçin Profesyonel\nBelgrad Adresi',
  'vo.desc': 'Belgrad\'da Topčiderska caddesinde kayıtlı adres - yabancı şirketler için ideal.',
  'vo.standard': 'Standart',
  'vo.premium': 'Premium',
  'vo.popular': 'En Popüler',
  'vo.month': '/ ay',
  'vo.getStarted': 'Başlayın',
  'vo.contact': 'İletişim',
  'vo.included': 'Tüm planlarda dahil',
  'cw.tag': 'Coworking Alanı',
  'cw.title': 'Belgrad Merkezinde\nModern Çalışma Alanları',
  'cw.desc': 'Verimlilik için tasarlanmış esnek coworking alanları.',
  'cw.hotDesk': 'Hot Desk',
  'cw.dedicatedDesk': 'Sabit Masa',
  'cw.privateOffice': 'Özel Ofis',
  'cw.month': '/ ay',
  'cw.getStarted': 'Başlayın',
  'cw.bookTour': 'Tur Rezervasyonu',
  'acc.tag': 'Muhasebe & Hukuk',
  'acc.title': 'İşletmeniz İçin Tam Finansal\nve Hukuki Destek',
  'acc.desc': 'Deneyimli muhasebeciler ve hukuk danışmanlarından oluşan ekibimiz.',
  'acc.basic': 'Temel',
  'acc.professional': 'Profesyonel',
  'acc.enterprise': 'Kurumsal',
  'acc.month': '/ ay',
  'acc.getStarted': 'Başlayın',
  'acc.consultation': 'Ücretsiz danışmanlık',
  'acc.pricing.title': 'Muhasebe Hizmetleri Fiyat Listesi',
  'acc.pricing.subtitle': 'Tüm fiyatlar Sırp Dinarı (RSD) cinsindendir. Fiyatlar minimum olup müzakereye açıktır.',
  'acc.pricing.service': 'Hizmet',
  'acc.pricing.clientPrice': 'Müşteri Fiyatı',
  'acc.pricing.regularPrice': 'Normal Fiyat',
  'acc.pricing.unit': 'Birim / açıklama',
  'acc.pricing.online': 'Online',
  'trust.tag': 'Neden Top14',
  'trust.title': 'Dünya Genelinde\nŞirketlerin Güveni',
  'trust.desc':
    '7 ülkeden 400\'den fazla şirket Sırbistan\'daki iş varlığı için Top14 ofis çözümlerini seçiyor.',
  'trust.companies': 'Aktif Şirketler',
  'trust.countries': 'Ülkeler',
  'trust.years': 'Yıllık Deneyim',
  'trust.satisfaction': 'Müşteri Memnuniyeti',
  'contact.tag': 'İletişime Geçin',
  'contact.title': 'Top14 ofis çözümleri',
  'contact.desc': 'Sırp iş varlığınızı kurmaya hazır mısınız? Bize mesaj gönderin.',
  'contact.address': 'Adres',
  'contact.phone': 'Telefon',
  'contact.email': 'E-posta',
  'contact.hours': 'Çalışma Saatleri',
  'contact.hoursValue': 'Pzt–Cum, 09:00–17:00 CET',
  'contact.addressValue': 'Topčiderska 14, 11000 Belgrad, Sırbistan',
  'contact.phoneValue': '+381 62 262 221',
  'contact.emailValue': 'office@top14.rs',
  'contact.mapStreet': 'Topčiderska caddesi',
  'contact.mapCity': 'Belgrad, Sırbistan',
  'contact.responseTime': 'Tipik Yanıt Süresi',
  'contact.responseValue': 'Çalışma saatlerinde 4 saat altında',
  'contact.weRespond': 'Yanıt veriyoruz',
  'contact.formTitle': 'Mesaj Gönderin',
  'contact.formDesc': 'Bir iş günü içinde yanıt vereceğiz.',
  'contact.name': 'Ad Soyad *',
  'contact.emailField': 'E-posta Adresi *',
  'contact.phoneField': 'İletişim telefon numarası *',
  'contact.placeholderPhone': '+381 60 123 4567',
  'contact.errPhone': 'Lütfen telefon numaranızı girin.',
  'contact.company': 'Şirket Adı',
  'contact.country': 'Ülke',
  'contact.officeLocation': 'Sanal ofis konumu *',
  'contact.selectOfficeLocation': 'Konum seçin…',
  'contact.location.belgrade': 'Belgrad, Topčiderska - Savski venac vergi dairesi',
  'contact.location.kovinPancevo': 'Kovin - Pančevo vergi dairesi (Sırbistan’daki en uygun maktu vergi)',
  'contact.location.loznica': 'Loznica, yakında (BiH yakını); ilginizi iletin',
  'contact.location.arandjelovac': 'Aranđelovac',
  'contact.errOfficeLocation': 'Lütfen ofis konumunu seçin.',
  'contact.service': 'İlgilenilen hizmetler *',
  'contact.selectService': 'Hizmet seçin...',
  'contact.placeholderName': 'Ahmet Yılmaz',
  'contact.placeholderEmail': 'ahmet@sirket.com.tr',
  'contact.placeholderCompany': 'Örnek A.Ş.',
  'contact.placeholderCountry': 'Türkiye',
  'contact.placeholderMessage':
    'Belgrad\'da sanal ofis ve şube tescili için destek arıyoruz. Lütfen adımları ve yaklaşık ücretleri özetleyin.',
  'contact.serviceRequired': 'En az bir hizmet seçin.',
  'contact.errName': 'Lütfen adınızı girin.',
  'contact.errEmail': 'Lütfen e-postanızı girin.',
  'contact.errEmailInvalid': 'Geçerli bir e-posta girin.',
  'contact.errMessage': 'Lütfen mesajınızı girin.',
  'contact.errMessageMin': 'Mesaj en az 20 karakter olmalıdır.',
  'contact.message': 'Mesaj *',
  'contact.messageHint': 'İş ihtiyaçlarınızı açıklayın.',
  'contact.send': 'Mesaj Gönder',
  'contact.sending': 'Gönderiliyor...',
  'contact.successTitle': 'Mesaj Gönderildi',
  'contact.successDesc': 'Teşekkürler. Ekibimiz bir iş günü içinde sizinle iletişime geçecek.',
  'contact.sendAnother': 'Başka Mesaj Gönder',
  'contact.services.vo': 'Sanal Ofis',
  'contact.services.cw': 'Coworking Alanı',
  'contact.services.acc': 'Muhasebe & Hukuki Destek',
  'contact.services.reg': 'Şirket Tescili',
  'contact.services.gen': 'Genel Soru',
  'contact.toast': 'Mesaj gönderildi! Bir iş günü içinde geri döneceğiz.',
  'contact.errorSend': 'Mesaj gönderilemedi. Lütfen biraz sonra tekrar deneyin.',
  'footer.desc':
    'Top14 - Sırbistan\'da faaliyet gösteren şirketler için profesyonel sanal ofis, coworking ve iş desteği.',
  'footer.services': 'Hizmetler',
  'footer.company': 'Şirket',
  'footer.contact': 'İletişim',
  'footer.about': 'Hakkımızda',
  'footer.howItWorks': 'Nasıl Çalışır',
  'footer.pricing': 'Fiyatlar',
  'footer.clientPortal': 'Müşteri Portalı',
  'footer.privacy': 'Gizlilik Politikası',
  'footer.terms': 'Kullanım Koşulları',
  'footer.cookies': 'Çerez Politikası',
  'legal.backHome': 'Ana sayfaya dön',
  'footer.rights': '© 2026 EVI Solutions DOO. Tüm hakları saklıdır.',
  'portal.adminDashboard': 'Yönetici Paneli',
  'portal.operatorDashboard': 'Operatör Paneli',
  'portal.roleBadgeAdmin': 'Yönetici',
  'portal.roleBadgeOperator': 'Operatör',
  'portal.roleBadgeClient': 'Müşteri',
  'portal.clientDashboard': 'Müşteri Paneli',
  'portal.signOut': 'Çıkış Yap',
  'portal.publicSite': 'Genel Site',
  'portal.settings': 'Ayarlar',
  'portal.password.title': 'Şifre değiştir',
  'portal.password.hint': 'E-posta ve şifre ile giriş yapan hesaplar için.',
  'portal.password.current': 'Mevcut şifre',
  'portal.password.new': 'Yeni şifre',
  'portal.password.confirm': 'Yeni şifre (tekrar)',
  'portal.password.submit': 'Şifreyi kaydet',
  'portal.password.saving': 'Kaydediliyor…',
  'portal.password.changed': 'Şifre güncellendi.',
  'portal.password.wrongCurrent': 'Mevcut şifre yanlış.',
  'portal.password.mismatch': 'Yeni şifreler eşleşmiyor.',
  'portal.password.tooShort': 'En az 8 karakter.',
  'portal.password.changeFailed': 'Şifre değiştirilemedi.',
  'portal.password.noEmail': 'Hesapta e-posta yok.',
  'portal.darkMode': 'Karanlık mod',
  'portal.notifications': 'Bildirimler',
  'portal.markAllRead': 'Tümünü okundu işaretle',
  'portal.viewAll': 'Tümünü görüntüle',
  'portal.notificationsPageTitle': 'Bildirimler',
  'portal.notificationsUnreadHint': 'okunmamış',
  'portal.notificationsAllCaughtUp': 'Hepsi görüldü',
  'portal.notificationsEmpty': 'Bildirim yok.',
  'portal.notificationsLoadError': 'Bildirimler yüklenemedi.',
  'portal.markAllReadDone': 'Tümü okundu olarak işaretlendi.',
  'portal.notificationsNeedCompany': 'Şirket bilgisi yüklendikten sonra bildirimler görünür.',
  'portal.notif.contactForm': 'İletişim formu mesajı: {{name}}',
  'portal.notif.newTask': 'Yeni görev talebi',
  'portal.profile': 'Profil',
  'portal.search': 'Şirket, belge ara...',
  'portal.company': 'Şirket',
  'portal.contactSupport': 'Destek ile İletişim',
  'portal.exportReport': 'Rapor Dışa Aktar',
  'portal.addCompany': 'Şirket Ekle',
  'portal.language': 'Dil',
  'portal.openMenu': 'Menüyü aç',
  'sidebar.main': 'Navigasyon',
  'sidebar.dashboard': 'Genel Bakış',
  'sidebar.myCompany': 'Şirketim',
  'sidebar.companies': 'Şirketler',
  'sidebar.documents': 'Belgeler',
  'sidebar.invoices': 'Faturalar',
  'sidebar.users': 'Kullanıcılar',
  'sidebar.calls': 'Gelen Aramalar',
  'sidebar.callsAdmin': 'Telefon aramaları',
  'sidebar.contacts': 'İletişim formu',
  'sidebar.notifications': 'Bildirimler',
  'sidebar.tasks': 'Görevler',
  'sidebar.taskRequests': 'Talepler',
  'admin.tab.dashboard': 'Genel Bakış',
  'admin.tab.companies': 'Şirketler',
  'admin.tab.documents': 'Belgeler',
  'admin.tab.invoices': 'Faturalar',
  'admin.tab.users': 'Kullanıcılar',
  'admin.tab.tasks': 'Görevler',
  'admin.tab.calls': 'Aramalar',
  'admin.tab.contacts': 'İletişim formu',
  'admin.contacts.title': 'İletişim formu talepleri',
  'admin.contacts.subtitle': 'talep',
  'admin.contacts.newBadge': 'yeni',
  'admin.contacts.unreadBadge': 'okunmadı',
  'admin.contacts.refresh': 'Yenile',
  'admin.contacts.loading': 'Yükleniyor…',
  'admin.contacts.empty': 'Henüz talep yok.',
  'admin.contacts.loadError': 'Talepler yüklenemedi.',
  'admin.contacts.updateError': 'Kaydedilemedi.',
  'admin.contacts.statusSaved': 'Durum kaydedildi.',
  'admin.contacts.noteSaved': 'Not kaydedildi.',
  'admin.contacts.col.date': 'Tarih',
  'admin.contacts.col.contact': 'İletişim',
  'admin.contacts.col.office': 'Ofis',
  'admin.contacts.col.services': 'Hizmetler',
  'admin.contacts.col.status': 'Durum',
  'admin.contacts.col.notes': 'İç not',
  'admin.contacts.affiliate': 'Affiliate',
  'admin.contacts.notePlaceholder': 'Anlaşma, sonraki adım…',
  'admin.contacts.saveNote': 'Notu kaydet',
  'admin.contacts.openMessage': 'Mesaj',
  'admin.contacts.close': 'Kapat',
  'admin.contacts.status.new': 'Yeni',
  'admin.contacts.status.contacted': 'İletişime geçildi',
  'admin.contacts.status.no_show_negotiations': 'Görüşmelerde yanıt yok',
  'admin.contacts.status.in_discussion': 'Görüşmede',
  'admin.contacts.status.became_client': 'Müşteri oldu',
  'admin.contacts.status.declined': 'Reddetti',
  'admin.contacts.status.spam': 'Spam',
  'admin.cancel': 'İptal',
  'admin.filters.title': 'Filtreler',
  'admin.filters.company': 'Şirket',
  'admin.filters.allCompanies': 'Tüm şirketler',
  'admin.filters.category': 'Belge türü',
  'admin.filters.allCategories': 'Tüm türler',
  'admin.filters.status': 'Durum',
  'admin.filters.allStatuses': 'Tüm durumlar',
  'admin.filters.dateFrom': 'Başlangıç',
  'admin.filters.dateTo': 'Bitiş',
  'admin.filters.priority': 'Öncelik',
  'admin.filters.allPriorities': 'Tümü',
  'admin.filters.reset': 'Temizle',
  'admin.users.title': 'Kullanıcı Yönetimi',
  'admin.users.total': 'kullanıcı',
  'admin.users.addUser': 'Kullanıcı Ekle',
  'admin.users.newUser': 'Yeni Kullanıcı',
  'admin.users.fullName': 'Ad Soyad',
  'admin.users.email': 'E-posta',
  'admin.users.password': 'Şifre',
  'admin.users.roleClient': 'Müşteri',
  'admin.users.roleOperator': 'Operatör',
  'admin.users.roleAdmin': 'Yönetici',
  'admin.users.operatorCannotEditAdmin': 'Operatörler yönetici hesaplarını düzenleyemez.',
  'admin.users.operatorCannotAssignAdmin': 'Operatörler Yönetici rolü atayamaz.',
  'admin.users.noCompany': 'Şirket atanmadı',
  'admin.users.create': 'Kullanıcı Oluştur',
  'admin.users.creating': 'Oluşturuluyor...',
  'admin.users.created': 'Kullanıcı oluşturuldu',
  'admin.users.createFailed': 'Kullanıcı oluşturma hatası',
  'admin.users.fillRequired': 'Lütfen tüm zorunlu alanları doldurun',
  'admin.users.passwordMin': 'Şifre en az 8 karakter olmalıdır',
  'admin.users.loading': 'Kullanıcılar yükleniyor...',
  'admin.users.noUsers': 'Kullanıcı bulunamadı',
  'admin.users.name': 'Ad',
  'admin.users.emailCol': 'E-posta',
  'admin.users.roleCol': 'Rol',
  'admin.users.companyCol': 'Şirket',
  'admin.users.assignCompany': 'Şirket Ata',
  'admin.users.none': 'Yok',
  'admin.users.assigned': 'Şirket atandı',
  'admin.users.assignFailed': 'Şirket atama hatası',
  'admin.users.actions': 'İşlemler',
  'admin.users.edit': 'Düzenle',
  'admin.users.resetPassword': 'Yeni şifre',
  'admin.users.editUser': 'Kullanıcıyı düzenle',
  'admin.users.saveChanges': 'Kaydet',
  'admin.users.updated': 'Kullanıcı güncellendi',
  'admin.users.updateFailed': 'Güncellenemedi',
  'admin.users.activeUser': 'Hesap aktif',
  'admin.users.resetPasswordTitle': 'Yeni şifre belirle',
  'admin.users.newPassword': 'Yeni şifre',
  'admin.users.confirmPassword': 'Şifre tekrar',
  'admin.users.passwordMismatch': 'Şifreler eşleşmiyor',
  'admin.users.passwordChanged': 'Şifre sıfırlandı',
  'admin.users.passwordChangeFailed': 'Şifre sıfırlanamadı',
  'admin.users.serverConfig':
    'Panelden şifre sıfırlamak için sunucuya SUPABASE_SERVICE_ROLE_KEY ekleyin.',
  'admin.calls.title': 'Telefon aramaları',
  'admin.calls.recent': 'son kayıtlı arama',
  'admin.calls.addCall': 'Arama kaydet',
  'admin.calls.newCall': 'Yeni arama',
  'admin.calls.selectCompany': 'Şirket *',
  'admin.calls.caller': 'Arayan',
  'admin.calls.callerPhone': 'Arayan numarası',
  'admin.calls.reason': 'Arama nedeni',
  'admin.calls.priority.low': 'Düşük',
  'admin.calls.priority.medium': 'Orta',
  'admin.calls.priority.high': 'Yüksek',
  'admin.calls.duration': 'Süre (dk, isteğe bağlı)',
  'admin.calls.notes': 'Notlar',
  'admin.calls.handledBy': 'İşleyen',
  'admin.calls.recording': 'Kayıt (isteğe bağlı)',
  'admin.calls.recordingHint': 'Ses dosyası ekleyin (MP3, WAV, M4A…)',
  'admin.calls.save': 'Aramayı kaydet',
  'admin.calls.saving': 'Kaydediliyor…',
  'admin.calls.saved': 'Arama kaydedildi',
  'admin.calls.saveFailed': 'Arama kaydedilemedi',
  'admin.calls.fillRequired': 'Şirket, arayan, numara ve neden zorunludur',
  'admin.calls.loading': 'Yükleniyor…',
  'admin.calls.noCalls': 'Henüz arama yok',
  'admin.calls.deleted': 'Arama silindi',
  'admin.calls.deleteFailed': 'Arama silinemedi',
  'admin.calls.openRecording': 'Kaydı dinle',
  'admin.calls.storageFailed': 'Kayıt yüklemesi başarısız',
  'admin.calls.delete': 'Aramayı sil',
  'admin.docs.title': 'Belge Yönetimi',
  'admin.docs.recent': 'son belge',
  'admin.docs.addDoc': 'Belge Ekle',
  'admin.docs.newDoc': 'Yeni Belge',
  'admin.docs.selectCompany': 'Şirket seçin *',
  'admin.docs.docName': 'Belge adı',
  'admin.docs.description': 'Belge açıklaması',
  'admin.docs.uploadPdf': 'PDF dosyası yükle',
  'admin.docs.category': 'Kategori',
  'admin.docs.fileUrl': 'Dosya URL (isteğe bağlı)',
  'admin.docs.fileSize': 'Dosya boyutu (örn. 284 KB)',
  'admin.docs.save': 'Belgeyi Kaydet',
  'admin.docs.saving': 'Kaydediliyor...',
  'admin.docs.uploaded': 'Belge eklendi',
  'admin.docs.uploadFailed': 'Belge ekleme hatası',
  'admin.docs.fillRequired': 'Şirket ve belge adı zorunludur',
  'admin.docs.operatorNoInvoiceCategory': 'Operatörler Faturalar kategorisinde belge yükleyemez.',
  'admin.docs.loading': 'Belgeler yükleniyor...',
  'admin.docs.noDocs': 'Henüz belge yok',
  'admin.docs.deleted': 'Belge silindi',
  'admin.docs.deleteFailed': 'Belge silme hatası',
  'admin.docs.storageUploadFailed': 'Dosya depolamaya yüklenemedi',
  'admin.docs.open': 'Aç',
  'admin.docs.noFile': 'Bu kayıt için dosya yok.',
  'admin.docs.openFailed': 'Dosya açılamadı.',
  'admin.docs.deleteFileFailed': 'Dosya depodan silinemedi',
  'admin.docs.cat.company': 'Şirket Belgeleri',
  'admin.docs.cat.archive': 'Arşiv Kitabı',
  'admin.docs.cat.mail': 'Gelen Posta',
  'admin.docs.cat.tax': 'Vergi Kutusu',
  'admin.docs.cat.registration': 'Tescil',
  'admin.docs.cat.lease': 'Kira',
  'admin.docs.cat.accounting': 'Muhasebe',
  'admin.docs.cat.other': 'Diğer',

  'docCat.CompanyLegal': 'Ticari sicil ve kuruluş belgeleri (APR, ana sözleşme, kararlar)',
  'docCat.StatutoryArchive': 'Zorunlu arşiv ve saklama',
  'docCat.MailForwarding': 'Posta ve yönlendirme (taramalar, gelen posta)',
  'docCat.TaxCompliance': 'Vergiler, primler ve beyannameler',
  'docCat.ContractsLeases': 'Sözleşmeler ve kiralama',
  'docCat.VirtualOfficeServices': 'Sanal ofis hizmetleri',
  'docCat.Accounting': 'Muhasebe ve mali tablolar',
  'docCat.Invoices': 'Faturalar',
  'docCat.Other': 'Diğer',
  'admin.invoices.title': 'Fatura Yönetimi',
  'admin.invoices.recent': 'son fatura',
  'admin.invoices.issue': 'Fatura Düzenle',
  'admin.invoices.newInvoice': 'Yeni Fatura',
  'admin.invoices.selectCompany': 'Şirket seçin *',
  'admin.invoices.description': 'Açıklama',
  'admin.invoices.amount': 'Tutar',
  'admin.invoices.dueDate': 'Son Ödeme Tarihi',
  'admin.invoices.create': 'Fatura Oluştur',
  'admin.invoices.creating': 'Oluşturuluyor...',
  'admin.invoices.created': 'Fatura oluşturuldu',
  'admin.invoices.createFailed': 'Fatura oluşturma hatası',
  'admin.invoices.fillRequired': 'Lütfen tüm zorunlu alanları doldurun',
  'admin.invoices.loading': 'Faturalar yükleniyor...',
  'admin.invoices.noInvoices': 'Henüz fatura yok',
  'admin.invoices.number': 'Fatura No.',
  'admin.invoices.companyCol': 'Şirket',
  'admin.invoices.descCol': 'Açıklama',
  'admin.invoices.amountCol': 'Tutar',
  'admin.invoices.statusCol': 'Durum',
  'admin.invoices.markedPaid': 'Ödendi olarak işaretlendi',
  'admin.invoices.updateFailed': 'Fatura güncelleme hatası',
  'admin.invoices.deleted': 'Fatura silindi',
  'admin.invoices.deleteFailed': 'Fatura silme hatası',
  'admin.invoices.invoiceNumberLabel': 'Fatura numarası (manuel)',
  'admin.invoices.issueDate': 'Düzenleme tarihi',
  'admin.invoices.attachmentLabel': 'Fatura eki (PDF veya görsel)',
  'admin.invoices.attachmentHint': 'Müşteri dosyayı portaldaki belgelerde görür.',
  'admin.invoices.chooseFile': 'Dosya seç',
  'admin.invoices.uploadingDoc': 'Ek yükleniyor...',
  'admin.invoices.duplicateNumber': 'Bu fatura numarası zaten var.',
  'admin.invoices.documentUploadFailed': 'Fatura oluşturuldu ancak ek yüklemesi başarısız',
  'admin.invoices.statusUpdated': 'Fatura durumu güncellendi',
  'admin.invoices.changeStatus': 'Durumu değiştir',
  'admin.invoices.deleteInvoice': 'Faturayı sil',
  'admin.invoices.editInvoice': 'Faturayı düzenle',
  'admin.invoices.saveChanges': 'Değişiklikleri kaydet',
  'admin.invoices.saving': 'Kaydediliyor...',
  'admin.invoices.updated': 'Fatura güncellendi',
  'admin.invoices.stPending': 'Beklemede',
  'admin.invoices.stPaid': 'Ödendi',
  'admin.invoices.stOverdue': 'Gecikmiş',
  'admin.invoices.stCancelled': 'İptal',
  'admin.companies.businessAddress': 'İş Adresi',
  'admin.companies.taxAddress': 'Vergi Adresi / Ayrı İş Birimi',
  'admin.companies.accountManager': 'Hesap Yöneticisi',
  'admin.companies.accountManagerEmail': 'Yönetici E-postası',
  'admin.companies.accountManagerPhone': 'Yönetici Telefonu',
  'admin.companies.phone': 'Şirket Telefonu',
  'admin.companies.email': 'Şirket E-postası',
  'admin.companies.regNumber': 'Tescil Numarası',
  'admin.companies.notes': 'Notlar',
  'admin.companies.sectionCompany': 'Şirket',
  'admin.companies.sectionManager': 'Hesap yöneticisi',
  'admin.companies.companyName': 'Şirket adı',
  'admin.companies.country': 'Ülke',
  'admin.companies.registrationAddress': 'Kayıt adresi ve şehri',
  'admin.companies.aprEmail': 'APR için resmi e-posta',
  'admin.companies.aprPhone': 'APR için resmi telefon',
  'admin.companies.ownerPhone': 'Sahibin doğrudan telefonu',
  'admin.companies.ownerEmail': 'Sahibin doğrudan e-postası',
  'admin.companies.pib': 'Vergi numarası (PIB)',
  'admin.companies.companyRegistrationDate': 'Şirket kayıt tarihi',
  'admin.companies.portalRegistrationDate': 'Portal kayıt tarihi',
  'admin.companies.managerName': 'Yönetici adı',
  'admin.companies.managerEmail': 'Yönetici e-postası',
  'admin.companies.managerContactPhone': 'İletişim telefonu',
  'admin.tasks.title': 'Talepler',
  'admin.tasks.noTasks': 'Talep yok',
  'admin.tasks.pending': 'Beklemede',
  'admin.tasks.submitted': 'Talep iletildi',
  'admin.tasks.ticketUrlPlaceholder': 'https://... muhasebeci bilet bağlantısı',
  'admin.tasks.saveUrl': 'Bağlantıyı kaydet',
  'admin.tasks.openTicket': 'Bileti aç',
  'admin.tasks.urlSaved': 'Bağlantı kaydedildi.',
  'admin.tasks.urlSaveFailed': 'Bağlantı kaydedilemedi.',
  'admin.tasks.targetAccountant': 'Muhasebe',
  'admin.tasks.targetSupport': 'Destek',
  'admin.tasks.urgency': 'Aciliyet',
  'admin.tasks.contactPref': 'İletişim',
  'admin.tasks.tabAccountant': 'Muhasebe',
  'admin.tasks.tabSupport': 'Destek',
  'admin.tasks.emptyAccountant': 'Henüz muhasebe talebi yok.',
  'admin.tasks.emptySupport': 'Henüz destek talebi yok.',
  'admin.tasks.supportStatusReceived': 'Alındı',
  'admin.tasks.supportStatusInProgress': 'İşleniyor',
  'admin.tasks.supportStatusCompleted': 'Tamamlandı',
  'admin.tasks.supportStatusLabel': 'Durum',
  'admin.tasks.supportStatusSaved': 'Durum güncellendi.',
  'admin.tasks.supportStatusSaveFailed': 'Durum kaydedilemedi.',
  'client.docs.title': 'Şirket Belgeleri',
  'client.docs.statsLine': '{{count}} belge · {{new}} yeni',
  'client.docs.search': 'Belge ara...',
  'client.docs.all': 'Tüm kategoriler',
  'client.docs.dateFrom': 'Başlangıç tarihi',
  'client.docs.dateTo': 'Bitiş tarihi',
  'client.docs.clearDates': 'Tarihleri temizle',
  'client.docs.noResults': 'Belge bulunamadı',
  'client.docs.adjustSearch': 'Arama veya filtreyi ayarlayın',
  'client.docs.download': 'İndir',
  'client.docs.preview': 'Önizleme',
  'client.docs.noFile': 'Dosya yok.',
  'client.docs.openFailed': 'Dosya açılamadı.',
  'client.docs.invoiceBadge': 'Fatura',
  'client.docs.loading': 'Belgeler yükleniyor...',
  'client.docs.loadFailed': 'Belgeler yüklenemedi.',
  'client.docs.uploadTitle': 'Belge yükle',
  'client.docs.uploadHint': 'Şirketinizle ilgili bir dosya yükleyin. PDF, görüntüler ve yaygın ofis formatları desteklenir.',
  'client.docs.docNamePlaceholder': 'Belge adı (isteğe bağlı)',
  'client.docs.chooseFile': 'Dosya seç',
  'client.docs.uploading': 'Yükleniyor...',
  'client.docs.submitUpload': 'Belgeyi gönder',
  'client.docs.uploaded': 'Belge yüklendi',
  'client.docs.uploadFailed': 'Yükleme başarısız',
  'client.docs.fillRequired': 'Lütfen bir dosya seçin.',
  'client.invoices.title': 'Faturalar & Ödemeler',
  'client.company.address': 'İş Adresi',
  'client.company.taxAddress': 'Vergi Adresi / Ayrı Birim',
  'client.company.fieldNotSet': 'Belirtilmedi',
  'client.company.country': 'Ülke',
  'client.company.registrationAddress': 'Kayıt adresi ve şehri',
  'client.company.companyEmail': 'Şirket e-postası',
  'client.company.aprEmail': 'Resmi APR e-postası',
  'client.company.aprPhone': 'Resmi APR telefonu',
  'client.company.ownerPhone': 'Sahip telefonu',
  'client.company.ownerEmail': 'Sahip e-postası',
  'client.company.pib': 'Vergi numarası (PIB)',
  'client.company.notesCompany': 'Notlar',
  'client.company.companyRegDate': 'Şirket kayıt tarihi',
  'client.company.portalRegDate': 'Portal kayıt tarihi',
  'client.company.start': 'Hizmet Başlangıcı',
  'client.company.renewal': 'Sonraki Yenileme',
  'client.company.plan': 'Plan',
  'client.company.manager': 'Hesap Yöneticiniz',
  'client.company.noCompany': 'Hesabınıza şirket atanmadı.',
  'client.company.contactManager': 'Yardım için hesap yöneticinizle iletişime geçin.',
  'company.plan.group.vo': 'Sanal Ofis',
  'company.plan.group.cw': 'Coworking',
  'company.plan.vo_starter': 'Başlangıç',
  'company.plan.vo_business': 'İş',
  'company.plan.vo_premium': 'Premium',
  'company.plan.cw_hot_desk': 'Hot Desk',
  'company.plan.cw_fixed_desk': 'Sabit masa',
  'company.plan.cw_private_office': 'Özel ofis',
  'client.kpi.docs': 'Toplam Belgeler',
  'client.kpi.invoices': 'Aktif Faturalar',
  'client.kpi.overdue': 'Vadesi Geçmiş Faturalar',
  'client.kpi.renewal': 'Sonraki Yenileme',
  'client.kpi.docsSub': 'Bu ay {{count}} yeni',
  'client.kpi.invoicesSub': '{{count}} ödeme bekliyor',
  'client.kpi.overdueSubOk': 'Tüm faturalar güncel',
  'client.kpi.overdueSubAction': 'Müdahale gerekli',
  'client.kpi.renewalValueDays': '{{count}} gün',
  'client.kpi.renewalDue': 'Vade: {{date}}',
  'client.kpi.renewalSubNone': 'Yenileme ayarlanmamış',
  'client.calls.title': 'Gelen Aramalar',
  'client.calls.caller': 'Arayan',
  'client.calls.phone': 'Telefon',
  'client.calls.date': 'Tarih & Saat',
  'client.calls.duration': 'Süre',
  'client.calls.notes': 'Notlar',
  'client.calls.noCalls': 'Gelen arama yok',
  'client.calls.minutes': 'dk',
  'client.calls.reason': 'Neden',
  'client.calls.priorityLow': 'Düşük öncelik',
  'client.calls.priorityMedium': 'Orta öncelik',
  'client.calls.priorityHigh': 'Yüksek öncelik',
  'client.calls.openRecording': 'Kaydı dinle',
  'client.calls.openRecordingFailed': 'Kayıt açılamadı',
  'client.task.button': 'Muhasebeciye Talep Gönder',
  'client.task.title': 'Muhasebeci İçin Yeni Talep',
  'client.task.subtitle': 'İhtiyacınızı açıklayın. Referans fiyat listesini gerektiğinde açın.',
  'client.task.taskTitle': 'Talep Başlığı',
  'client.task.taskDesc': 'Talep Açıklaması',
  'client.task.send': 'Talebi Gönder',
  'client.task.sending': 'Gönderiliyor...',
  'client.task.sent': 'Talep gönderildi!',
  'client.task.failed': 'Talep gönderme hatası',
  'client.task.fillRequired': 'Talep başlığı zorunludur',
  'client.task.pricing': 'Hizmet Fiyat Listesi',
  'client.task.pricingInfo': 'Fiyat Bilgisi',
  'client.task.selectServiceLabel': 'Fiyat listesinden hizmet',
  'client.task.selectServicePlaceholder': 'Hizmet seçin (başlık ve açıklamayı doldurur)',
  'client.task.lblCategory': 'Kategori',
  'client.task.lblService': 'Hizmet',
  'client.task.lblPriceRsd': 'Fiyat (müşteriler, RSD)',
  'client.task.lblUnit': 'Birim',
  'client.task.autoDescFooter': 'Aşağıya süre, özel istekler veya sorular ekleyin.',
  'client.task.fullPricingOnSite': 'Sitede tam fiyat listesini görüntüle',
  'client.support.title': 'Destek ile iletişim',
  'client.support.subtitle': 'Sorununuzu açıklayın. En kısa sürede size döneriz.',
  'client.support.fieldTitle': 'Başlık',
  'client.support.fieldMessage': 'Mesaj',
  'client.support.urgency': 'Aciliyet',
  'client.support.urgencyLow': 'Düşük',
  'client.support.urgencyMedium': 'Orta',
  'client.support.urgencyHigh': 'Yüksek',
  'client.support.contactPref': 'Size nasıl ulaşalım?',
  'client.support.contactEmail': 'E-posta',
  'client.support.contactPhone': 'Telefon',
  'client.support.contactBoth': 'E-posta veya telefon',
  'client.support.send': 'Gönder',
  'client.support.sending': 'Gönderiliyor...',
  'client.support.sent': 'Mesajınız gönderildi.',
  'client.support.failed': 'Gönderilemedi. Lütfen tekrar deneyin.',
  'client.support.fillTitle': 'Başlık gerekli.',
  'client.support.fillMessage': 'Mesaj gerekli.',
  'client.taskRequests.title': 'Talepler',
  'client.taskRequests.loading': 'Talepler yükleniyor...',
  'client.taskRequests.noTasks': 'Henüz gönderilmiş talep yok',
  'client.taskRequests.pending': 'Beklemede',
  'client.taskRequests.submitted': 'Talep iletildi',
  'client.taskRequests.createdAt': 'Oluşturuldu',
  'client.taskRequests.submittedAt': 'Muhasebeciye iletildi',
  'client.taskRequests.openTicket': 'Bileti aç',
  'client.taskRequests.waitingForTicket': 'Yönetici bilet bağlantısını ekleyene kadar bekleniyor',
  'client.taskRequests.targetAccountant': 'Muhasebe',
  'client.taskRequests.targetSupport': 'Destek',
  'client.taskRequests.urgency': 'Aciliyet',
  'client.taskRequests.contactPref': 'İletişim',
  'client.taskRequests.tabAccountant': 'Muhasebe',
  'client.taskRequests.tabSupport': 'Destek',
  'client.taskRequests.emptyAccountant': 'Henüz muhasebe talebi yok.',
  'client.taskRequests.emptySupport': 'Henüz destek talebi yok.',
  'client.taskRequests.supportStatusReceived': 'Alındı',
  'client.taskRequests.supportStatusInProgress': 'İşleniyor',
  'client.taskRequests.supportStatusCompleted': 'Tamamlandı',
  'client.taskRequests.updatedAt': 'Güncellendi',
  'login.title': 'Giriş Yap',
  'login.subtitle': 'Müşteri portalı',
  'login.desc': 'Portala erişmek için kimlik bilgilerinizi girin',
  'login.email': 'E-posta Adresi',
  'login.password': 'Şifre',
  'login.signIn': 'Giriş Yap',
  'login.signingIn': 'Giriş yapılıyor...',
  'login.fillRequired': 'Lütfen e-posta ve şifrenizi girin',
  'login.invalidCredentials': 'Geçersiz e-posta veya şifre',
  'login.forgotPassword': 'Şifremi unuttum',
  'login.forgotTitle': 'Şifre sıfırlama',
  'login.forgotDesc': 'Hesap e-posta adresinizi girin. Yeni şifre için bağlantı göndereceğiz.',
  'login.sendResetLink': 'Bağlantı gönder',
  'login.sendingReset': 'Gönderiliyor…',
  'login.resetSent': 'Hesap varsa e-postanızı kontrol edin: talimat gönderildi.',
  'login.resetEmailRequired': 'E-posta adresini girin.',
  'login.resetFailed': 'Gönderilemedi. Tekrar deneyin.',
  'login.backToSignIn': 'Girişe dön',
  'login.resetLoading': 'Yükleniyor…',
  'login.resetPasswordTitle': 'Yeni şifre',
  'login.resetPasswordDesc': 'Hesabınız için yeni bir şifre girin.',
  'login.newPassword': 'Yeni şifre',
  'login.confirmPassword': 'Şifreyi onaylayın',
  'login.passwordMismatch': 'Şifreler eşleşmiyor.',
  'login.passwordTooShort': 'Şifre en az 6 karakter olmalıdır.',
  'login.saveNewPassword': 'Şifreyi kaydet',
  'login.savingPassword': 'Kaydediliyor…',
  'login.passwordUpdated': 'Şifre güncellendi.',
  'login.redirectingToLogin': 'Giriş sayfasına yönlendiriliyorsunuz…',
  'login.resetInvalid': 'Bu bağlantı geçersiz veya süresi dolmuş. Giriş sayfasından yenisini isteyin.',
  'admin.companies.addNew': 'Yeni şirket ekle',
  'admin.companies.save': 'Şirketi kaydet',
  'admin.companies.saveChanges': 'Değişiklikleri kaydet',
  'admin.companies.edit': 'Şirketi düzenle',
  'admin.companies.editTitle': 'Şirketi düzenle',
  'admin.companies.editDrawerHint': 'Aşağıdaki alanları güncelleyin ve kaydedin.',
  'admin.companies.view': 'Görüntüle',
  'admin.companies.delete': 'Sil',
  'admin.companies.edit2': 'Düzenle',
  'admin.companies.noMatch': 'Aramanızla eşleşen şirket yok',
  'admin.companies.loading': 'Şirketler yükleniyor...',
  'admin.companies.taxLabel': 'Vergi',
  'admin.companies.colName': 'Şirket',
  'admin.companies.colCountry': 'Ülke',
  'admin.companies.colPlan': 'Plan',
  'admin.companies.colStatus': 'Durum',
  'admin.companies.detailBadge': 'Şirket',
  'admin.companies.sectionInfo': 'Şirket bilgileri',
  'admin.companies.sectionDocuments': 'Belgeler',
  'admin.companies.sectionFinance': 'Finans ve faturalar',
  'admin.companies.financeTotalPaid': 'Toplam ödenen (tüm zamanlar)',
  'admin.companies.financePaidCount': 'Ödenen faturalar',
  'admin.companies.financePending': 'Bekleyen ödeme',
  'admin.companies.financeOverdue': 'Gecikmiş',
  'admin.companies.detailNoDocuments': 'Bu şirket için henüz belge yok.',
  'admin.companies.recentInvoices': 'Son faturalar',
  'admin.companies.openDoc': 'Aç',
  'admin.companies.detailLoading': 'Yükleniyor…',
  'admin.companies.serviceStart': 'Hizmet başlangıcı',
  'admin.companies.nextRenewal': 'Sonraki yenileme',
  'admin.companies.searchPlaceholder': 'Şirket ara...',
  'admin.companies.countOf': '/',
  'admin.companies.companiesWord': 'şirket',
  'admin.companies.addShort': 'Ekle',
  'admin.companies.refreshTitle': 'Yenile',
  'admin.companies.filterAll': 'Tümü',
  'admin.companies.statusActive': 'Aktif',
  'admin.companies.statusPending': 'Beklemede',
  'admin.companies.statusSuspended': 'Askıda',
  'admin.companies.statusArchived': 'Arşivlendi',
  'admin.revenue.title': 'Aylık gelir',
  'admin.revenue.subtitle': 'Son 12 ay · ödenen faturalar',
  'admin.revenue.totalLabel': 'Toplam (12 ay):',
  'admin.revenue.invoices': 'fatura',
  'admin.quick.title': 'Hızlı İşlemler',
  'admin.quick.uploadDoc': 'Belge Yükle',
  'admin.quick.uploadDocDesc': 'Şirkete belge ekle',
  'admin.quick.addCompany': 'Şirket Ekle',
  'admin.quick.addCompanyDesc': 'Yeni müşteri kaydet',
  'admin.quick.issueInvoice': 'Fatura Düzenle',
  'admin.quick.issueInvoiceDesc': 'Yeni fatura oluştur',
  'admin.quick.addUser': 'Kullanıcı Ekle',
  'admin.quick.addUserDesc': 'Portal erişimi ata',
  'admin.quick.addCall': 'Çağrı ekle',
  'admin.quick.addCallDesc': 'Gelen çağrıyı kaydet',
  'admin.quick.generateReport': 'Rapor Oluştur',
  'admin.quick.generateReportDesc': 'Şirket raporu dışa aktar',
  'admin.quick.portalSettings': 'Portal Ayarları',
  'admin.quick.portalSettingsDesc': 'Portal yapılandırmasını yönet',
  'admin.quick.pendingTasks': 'Bekleyen Görevler',
  'admin.quick.noTasks': 'Bekleyen görev yok',
  'admin.quick.portalHealth': 'Portal Sağlığı',
  'admin.quick.docCoverage': 'Belge kapsamı',
  'admin.quick.collectionRate': 'Fatura tahsilat oranı',
  'admin.quick.activeCompanies': 'Aktif şirketler',
  'admin.activity.title': 'Son Aktiviteler',
  'admin.activity.subtitle': 'Canlı portal aktivite akışı',
  'admin.activity.viewAll': 'Tüm aktivite günlüğünü görüntüle',
  'admin.activity.noActivity': 'Son aktivite yok',
  'admin.activity.docUploaded': 'Belge yüklendi -',
  'admin.activity.invoiceOverdue': 'Fatura gecikmiş -',
  'admin.activity.paymentReceived': 'Ödeme alındı -',
  'admin.activity.invoiceIssued': 'Fatura düzenlendi -',
  'admin.activity.newPending': 'Yeni şirket onay bekliyor',
  'admin.activity.newOnboarded': 'Yeni şirket kaydedildi',
  'admin.activity.contactForm': 'İletişim formundan yeni mesaj',
  'admin.kpi.activeCompanies': 'Aktif Şirketler',
  'admin.kpi.currentlyActive': 'Şu anda aktif',
  'admin.kpi.pendingDocs': 'Bekleyen Belgeler',
  'admin.kpi.awaitingUpload': 'Yükleme bekliyor',
  'admin.kpi.outstandingInvoices': 'Ödenmemiş Faturalar',
  'admin.kpi.pendingPayment': 'Ödeme bekliyor',
  'admin.kpi.overdueInvoices': 'Gecikmiş Faturalar',
  'admin.kpi.actionRequired': 'İşlem gerekli',
  'admin.kpi.revenue': 'Gelir -',
  'admin.kpi.paidThisMonth': 'Bu ay ödenen faturalar',
  'admin.kpi.newCompanies': 'Yeni Şirketler (30g)',
  'admin.kpi.onboardedThisMonth': 'Bu ay kayıt edildi',
  'admin.kpi.urgent': 'ACİL',
  'admin.kpi.contactForm': 'İletişim formu',
  'admin.kpi.contactFormSub': 'Siteden toplam talep',
  'admin.kpi.contactFormUnread': 'Okunmamış talepler',
  'admin.kpi.contactFormUnreadSub': 'Panelde açılmadı',
  'client.notif.document': 'Yeni belge:',
  'client.notif.invoiceIssued': 'Fatura:',
  'client.notif.invoicePaid': 'Ödenen fatura:',
  'client.notif.task': 'Talep',
  'client.notif.call': 'Arama',
  'client.invoices.loading': 'Faturalar yükleniyor...',
  'client.invoices.noInvoices': 'Fatura bulunamadı',
  'client.invoices.pending': 'ödeme bekliyor',
  'client.invoices.viewAll': 'Tümünü Görüntüle',
  'client.invoices.colInvoice': 'Fatura',
  'client.invoices.colDesc': 'Açıklama',
  'client.invoices.colIssued': 'Düzenleme Tarihi',
  'client.invoices.colDue': 'Son Ödeme',
  'client.invoices.colAmount': 'Tutar',
  'client.invoices.colStatus': 'Durum',
  'client.invoices.view': 'Faturayı görüntüle',
  'client.invoices.downloadAttachment': 'Ekli dosyayı indir',
  'client.invoices.openAttachment': 'Ekli dosyayı aç',
  'client.invoices.noAttachment': 'Bu faturaya dosya eklenmemiş.',
  'client.invoices.openFailed': 'Dosya açılamadı.',
  'client.invoices.downloadedOk': '{{n}} numaralı fatura dosyası açıldı',
  'portal.languageHint': 'Dili üst menüden değiştirin',
  'portal.emailLanguage': 'E-posta bildirim dili',
  'portal.emailLanguageHint':
    'Portalden gelen işlem e-postaları (faturalar, ekip belgeleri, aramalar, gecikme hatırlatmaları) bu dilde gönderilir.',
  'portal.emailLanguageSaved': 'E-posta dili kaydedildi.',

  // VirtualOfficeSection
  'vo.sectionTitle': 'Sırp İş Adresi,\nOfis Masrafı Olmadan',
  'vo.sectionDesc': 'İlk günden itibaren güvenilir, yasal olarak kayıtlı bir Sırp iş varlığı oluşturun - fiziksel ofis maliyeti ve taahhüdü olmadan.',
  'vo.benefit1.title': 'Prestijli Belgrad Adresi',
  'vo.benefit1.desc': 'Topčiderska caddesi, Savski venac belediyesi - koruma altındaki yeşil alanda yer alan iş bölgesi, Belgrad merkezine yakın.',
  'vo.benefit2.title': 'Posta Alımı ve İletimi',
  'vo.benefit2.desc': 'İş yazışmalarınızı alıyor, tarıyor ve nerede olursanız olun iletiyoruz.',
  'vo.benefit3.title': 'Tescil Desteği',
  'vo.benefit3.desc': 'Gerekli adres belgelerini sağlayarak APR şirket tescilinde yardımcı oluyoruz.',
  'vo.benefit4.title': 'Yabancı Şirketlere Uygun',
  'vo.benefit4.desc': 'Fiziksel taşınma olmadan yasal Sırp varlığına ihtiyaç duyan uluslararası şirketler için ideal.',
  'vo.benefit5.title': 'Yasal Uyumlu',
  'vo.benefit5.desc': 'Sırp ticaret hukuku ve APR tescil gereksinimleriyle tam uyumlu.',
  'vo.benefit6.title': '48 Saat İçinde Aktif',
  'vo.benefit6.desc': 'Adresiniz ve portal erişiminiz imzalamadan itibaren iki iş günü içinde hazır.',
  'vo.legalHighlight':
    'Sırbistan’da yalnızca biz, Sırbistan Cumhuriyeti’nin tüm kanunlarına uygun, %100 yasal sanal ofis sunuyoruz.',
  'vo.whoFor': 'Kimler İçin',
  'vo.whoFor1': 'Sırp pazarına giren yabancı şirketler',
  'vo.whoFor2': 'Sırp KDV adresi gerektiren e-ticaret işletmeleri',
  'vo.whoFor3': 'Profesyonel iş adresi isteyen serbest çalışanlar ve danışmanlar',
  'vo.whoFor4': 'Fiziksel ofis alanını küçülten şirketler',
  'vo.whoFor5': 'Personel almadan önce kayıtlı adres gerektiren girişimler',
  'vo.plansTitle': 'Sanal ofis paketi',
  'vo.plansDesc':
    'Tek paket aşağıda listelenen her şeyi kapsar. Adresi ve vergi dairesini iş ve vergi önceliklerinize göre seçersiniz.',
  'vo.requestQuote': 'Teklif İste',
  'vo.pack.title': 'Sanal ofis',
  'vo.pack.tagline': 'Tek fiyat, tek paket - adres, posta ve portal.',
  'vo.pack.priceRsd': '3.500 RSD',
  'vo.pack.priceEur': '~30 EUR',
  'vo.pack.annualNote': 'Yıllık ödemede 2 ay ücretsiz',
  'vo.pack.f1': 'Belgrad veya Kovin (Pančevo vergi dairesi) iş adresi; Loznica yakında, ilginizi iletin',
  'vo.pack.f2': 'Gelen posta için e-posta bildirimi',
  'vo.pack.f3':
    'Gelen postanın taranması, tarananların e-postayla gönderilmesi ve müşteri portalına yüklenmesi',
  'vo.pack.f4': 'Ortak posta kutusuna teslim alım',
  'vo.pack.f5': 'Dokümantasyon için ayrı klasör (registratör)',
  'vo.pack.f6': 'Coworking ve toplantı odalarında indirim',
  'vo.pack.f7': 'Dokümantasyonunuzu takip etmek için dijital portala erişim',

  'vo.addOns.tag': 'EK HİZMETLER',
  'vo.addOns.title': 'Sanal ofise ek hizmetler',
  'vo.addOns.subtitle': 'İhtiyacınıza göre paketi genişletin; sabit fiyat verilebildiğinde şeffaf kalemler.',
  'vo.addOns.1.title': 'Telefon santrali / arama karşılama',
  'vo.addOns.1.desc':
    'Aramaları sizin adınıza alırız. Numaramızı APR’ye kaydedebilirsiniz; tüm aramaları işler ve kimin aradığını bildiririz.',
  'vo.addOns.1.price': '+500 RSD / ay',
  'vo.addOns.2.title': 'Belge inceleme ve vergi danışmanlığı',
  'vo.addOns.2.desc': 'Avukat ekibimiz tüm belge türlerini özel fiyatla açıklayabilir.',
  'vo.addOns.2.price': 'Görüşmeye bağlı',
  'vo.addOns.3.title': 'Çevre (EKO) harcı başvurusu',
  'vo.addOns.3.desc': 'Faaliyet gösterdiğimiz belediyelerde EKO harcı için başvuru hizmeti.',
  'vo.addOns.3.price': '3.000 RSD / başvuru',
  'vo.addOns.4.title': 'Özel posta kutusu ve tabela',
  'vo.addOns.4.desc': 'Kendi posta kutunuz ve üzerindeki tabela ile öne çıkın. Kutu ölçüsü 370 × 250 × 90 mm.',
  'vo.addOns.4.price': '+1.000 RSD / ay',
  'vo.addOns.5.title': 'Toplantı odası',
  'vo.addOns.5.desc': 'Mekânımızda tanıtım fiyatlarıyla toplantı odası rezerve edin.',
  'vo.addOns.5.price': 'Görüşmeye bağlı',
  'vo.addOns.6.title': 'Fiziksel posta yönlendirme',
  'vo.addOns.6.desc':
    'Tek evrak veya birden fazla gönderi; talimatınıza göre hızlı veya kayıtlı posta ile.',
  'vo.addOns.6.price': '+500 RSD + PTT',

  'vo.extraBenefits.tag': 'SANAL OFİS',
  'vo.extraBenefits.title': 'Sanal ofis avantajları',
  'vo.extraBenefits.desc': 'Kayıtlı iş adresiyle şirketinizin elde ettiği ek avantajlar.',
  'vo.extraBenefits.1.title': 'İş adresi koruması',
  'vo.extraBenefits.1.desc':
    'Kayıtlı adresiniz APR kaydında tutarlı ve net kalır; yazışmaların profesyonelce yönetilmesiyle iş adresiniz kötüye kullanıma karşı korunur.',
  'vo.extraBenefits.2.title': 'Telefon numarası koruması',
  'vo.extraBenefits.2.desc':
    'İş iletişimi adresimiz üzerinden yönlendirilebilir; böylece özel numaralar ve kişisel veriler kamu iş profilinden ayrı kalır.',
  'vo.extraBenefits.3.title': 'Belgrad\'ın daha uygun vergi bölgelerinden biri',
  'vo.extraBenefits.3.desc':
    'Şehir içinde nispeten daha uygun bölgelerden birinde konum; toplam işletme ve vergiyle ilgili maliyetleri olumlu etkileyebilir.',
  'vo.extraBenefits.4.title': 'Posta kutusu ve tabela her zaman adreste',
  'vo.extraBenefits.4.desc':
    'Fiziksel posta kutusu ve şirket tabelası adreste her zaman bulunur; postanın iade edilmesini ve uygun tabela ile adreste posta alımını gerektiren denetimlerde yaşanabilecek sorunları azaltmaya yardımcı olur.',
  'vo.extraBenefits.5.title': 'Posta arşivi ve defter',
  'vo.extraBenefits.5.desc':
    'Gelen posta kurallara uygun şekilde kayıt altına alınır ve arşivlenir; defterin tutulması ve saklanması için güvenli alan sağlanır.',
  'vo.extraBenefits.6.title': 'Vergi müfettişi karşılama',
  'vo.extraBenefits.6.desc':
    'Yetkili bir kişi her zaman vergi müfettişini karşılamak ve gerekli belgeleri yerinde sunmak için hazırdır.',

  'pausalBanner.text':
    'Ofisimiz yeşil alan koruma bölgesinde, Savski venac belediyesi. Kovin (Pančevo vergi dairesi) adresi de sunuyoruz; Loznica konumu yakında, bu seçenek için ilginizi iletin.',
  'pausalBanner.button': 'Sabit vergi hesaplayıcısı',
  'pausalBanner.textInlineLink':
    'Faaliyetinizin sabit (basit) vergi kapsamında olup olmadığını bu sayfada kontrol edin.',
  'pausalBanner.aria': 'Sabit vergi – Vergi İdaresi hesaplayıcı bağlantısı',

  // CoworkingSection
  'cw.sectionTitle': 'Belgrad\'ın Kalbinde\nProfesyonel Çalışma Alanı',
  'cw.sectionDesc': 'Verimlilik ve iş birliği için tasarlandı. Temiz, sessiz, iş odaklı bir ortamda diğer profesyonellerle çalışın.',
  'cw.amenity1': 'Gigabit İnternet',
  'cw.amenity1.desc': '1 Gbps fiber',
  'cw.amenity2': 'Kahve ve Mutfak',
  'cw.amenity2.desc': 'Tam donanımlı',
  'cw.amenity3': 'Çift Monitör',
  'cw.amenity3.desc': 'İstek üzerine',
  'cw.amenity4': 'Toplantı Odaları',
  'cw.amenity4.desc': '3 mevcut',
  'cw.amenity5': 'Esnek Rezervasyon',
  'cw.amenity5.desc': 'Gün veya ay',
  'cw.amenity6': '24 Saat Güvenli Erişim',
  'cw.amenity6.desc': 'Kart girişi',
  'cw.plan.hotDesk.desc': 'Herhangi bir hafta içi günü kullanılabilen esnek açık masa. Serbest çalışanlar için ideal.',
  'cw.plan.hotDesk.f1': 'Herhangi bir müsait masa',
  'cw.plan.hotDesk.f2': 'Hafta içi erişim',
  'cw.plan.hotDesk.f3': 'Dolap depolama',
  'cw.plan.hotDesk.f4': 'Toplantı odası kredisi (2sa/ay)',
  'cw.plan.dedicated.desc': 'Kendi rezerve masanız, kilitli depolama ve coworking alanında kalıcı çalışma yeri.',
  'cw.plan.dedicated.f1': 'Rezerve masa 24/7',
  'cw.plan.dedicated.f2': 'Kilitli dolap',
  'cw.plan.dedicated.f3': 'İş adresi eklentisi mevcut',
  'cw.plan.dedicated.f4': 'Toplantı odası kredisi (5sa/ay)',
  'cw.plan.private.desc': '1–4 kişilik tamamen kapalı özel ofis. Kilitli depolama ve toplantı odası saatleri dahil.',
  'cw.plan.private.f1': 'Kapalı özel ofis',
  'cw.plan.private.f2': '4 çalışma istasyonuna kadar',
  'cw.plan.private.f3': 'Özel toplantı odası (10sa/ay)',
  'cw.plan.private.f4': 'Kapıda özel marka',

  // AccountingSection
  'acc.sectionTitle': 'Sırbistan İçin Profesyonel\nİş Desteği',
  'acc.sectionDesc': 'Vergi İdaresi\'nde kaçırılan bir süre, hatalı bir KDV beyanı veya mevzuata uygun olmayan bir adres cezalara ve işlerin aksamasına yol açabilir - özellikle Sırpça bilmiyorsanız ve APR kurallarına hakim değilseniz. Ekibimiz beş dilde çalışır, bu karmaşıklığı üstlenir ve süreleri sizin yerinize takip eder; siz işinize odaklanın.',
  'acc.svc1.title': 'Muhasebe ve Defter Tutma',
  'acc.svc1.desc': 'Sırp muhasebe standartlarına (MSFI/MRS) uygun aylık muhasebe, finansal tablo hazırlama ve uyumluluk raporlaması.',
  'acc.svc1.tag1': 'Aylık raporlar',
  'acc.svc1.tag2': 'MSFI/MRS uyumlu',
  'acc.svc2.title': 'Vergi ve KDV Kaydı',
  'acc.svc2.desc': 'KDV kaydı, üç aylık KDV beyannameleri, kurumlar vergisi beyannamesi ve Vergi İdaresi\'ndeki tüm yasal son tarihler.',
  'acc.svc2.tag1': 'KDV kaydı',
  'acc.svc2.tag2': 'Üç aylık beyannameler',
  'acc.svc3.title': 'Hukuki Belge Desteği',
  'acc.svc3.desc': 'Sırp ticaret ve iş hukukuna uygun sözleşme, iş sözleşmesi ve iş belgelerinin hazırlanması ve incelenmesi.',
  'acc.svc3.tag1': 'Sözleşme hazırlama',
  'acc.svc3.tag2': 'İş hukuku',
  'acc.svc4.title': 'Çok Dilli Danışmanlık',
  'acc.svc4.desc': 'Ekibimiz Sırpça, İngilizce, Rusça, Türkçe ve Almanca danışmanlık hizmeti sunar.',
  'acc.svc4.tag1': '5 dil',
  'acc.svc4.tag2': 'Uluslararası müşteriler',
  'acc.stat1.label': 'Yıllık Deneyim',
  'acc.stat1.sub': 'Sırp iş hukukunda',
  'acc.stat2.label': 'Desteklenen Müşteri',
  'acc.stat2.sub': 'yerel ve uluslararası',
  'acc.stat3.label': 'Dil',
  'acc.stat3.sub': 'danışmanlık dilleri',
  'acc.stat4.label': 'Vergi Beyannamesi',
  'acc.stat4.sub': '2014\'ten bu yana',
  'acc.cta.title': 'Ücretsiz Danışmanlık Rezervasyonu',
  'acc.cta.desc': 'Muhasebe veya hukuk danışmanlarımızdan biriyle özel iş durumunuz hakkında konuşun. Sırpça, İngilizce, Rusça, Türkçe ve Almanca mevcuttur.',
  'acc.cta.btn': 'Görüşme Planla',
  'acc.pricing.show': 'Fiyat listesini göster',
  'acc.pricing.hide': 'Fiyat listesini gizle',
  'acc.pricing.footer': 'Tüm fiyatlar Sırp Dinarı (RSD) cinsindendir. Minimum fiyatlar, müzakereye açıktır. ✓ tamamen çevrimiçi sunulabilen hizmetleri gösterir.',

  // TrustSection
  'trust.statsTitle': 'Dünya genelinde şirketlerin güveni',
  'trust.stat1': 'Kayıtlı Şirket',
  'trust.stat2': 'Yönetilen Belge',
  'trust.stat3': 'Yıllık Deneyim',
  'trust.stat4': 'Hizmet Verilen Ülke',
  'trust.trustedBy': 'Avrupa ve ötesinden şirketlerin güveni',
  'trust.testimonialsTag': 'Müşteri Görüşleri',
  'trust.testimonialsTitle': 'Müşterilerimiz Ne Diyor',
  'trust.test1.text':
    'AB operasyonlarımızı genişletmek için Sırp iş adresine ihtiyaç duyduk. Top14 ofis çözümleri tescil, belgeler ve postayı üstlendi. Müşteri portalı her şeyi inanılmaz kolaylaştırıyor.',
  'trust.test1.highlight': '48 saatten kısa sürede tescil edildi',
  'trust.test2.text':
    'Rus bir girişimci olarak Sırbistan\'da güvenilir bir ortağa ihtiyaç duydum. Top14 çok dilli destek sağladı; KDV kaydı ve süreç baştan sona sorunsuz geçti.',
  'trust.test2.highlight': 'Çok dilli destek fark yarattı',
  'trust.test3.text':
    'Coworking alanı profesyonel ve iyi donanımlı. Top14 ofis çözümleri Sırbistan\'dayken Belgrad\'daki üssüm: harika internet, sessiz ortam ve yardımsever ekip.',
  'trust.test3.highlight': 'Belgrad\'daki favori çalışma alanım',

  'partners.tag': 'Partnerler',
  'partners.title': 'İş ortaklarımız',
  'partners.desc':
    'Top14 ekosistemini tamamlayan ekipler: dijital varlık, finans, yapay zekâ ve eğitim.',
  'partners.evi.name': 'EVI Solutions',
  'partners.evi.desc':
    'Güçlü bir web sitesi genelde ciddi operasyonların ilk adımıdır. Buna ek olarak EVI portallar, e‑ticaret ve uygulamalar geliştirir; ölçeklenirken dijital katmanınızın güvenilir kalması için profesyonel IT operasyonu sunar.',
  'partners.tim011.name': 'Tim011 Digital',
  'partners.tim011.desc':
    'Şahıs şirketi veya şirket kurulumunda hız ve çevrimiçi muhasebeye odaklanan bir ortak. Günlük işlerde güvenilir destek ve daha net vergi konumlandırması, siz işi yönetin, evrak yığınını değil.',
  'partners.intrascope.name': 'Intrascope',
  'partners.intrascope.desc':
    'Şirketiniz için tek bir AI çalışma alanı: önde gelen modeller tek yerde, paylaşılan bağlam ve ekip içi kontrol. TOP150 promosyon kodu ile yıllık planın ilk satın alımında 150 USD indirim.',
  'partners.capitaale.name': 'Capitaale',
  'partners.capitaale.desc':
    'Capitaale, yurt dışından faturalandıran girişimciler için bir uygulamadır. Banka kuru sonrası gerçek RSD bakiyesi, canlı pausal limiti, tek bir müşteri gelirin %70\'ini geçtiğinde uyarı ve 60 saniyede EUR veya USD fatura. İlk 7 gün ücretsiz.',

  // Footer hardcoded items
  'footer.businessAddress': 'İş Adresi',
  'footer.legalAssistance': 'Hukuki Yardım',
  'footer.companyRegistration': 'Şirket Tescili',

  // Blog
  'blog.subtitle': 'Belgrad ve Sırbistan’da sanal ofis, şirket kurulumu ve iş adresi hakkında rehberler.',
  'blog.readMore': 'Devamını oku',
  'blog.backToBlog': 'Bloga dön',
  'blog.related': 'İlgili yazılar',
  'blog.published': 'Yayınlanma',
  'blog.minRead': 'dk okuma',
  'blog.ctaTitle': 'Belgrad’da sanal ofise hazır mısınız?',
  'blog.ctaDesc': 'Danışmanlık alın ve Top14’in Sırbistan’daki işinizi nasıl destekleyeceğini öğrenin.',
  'blog.ctaBtn': 'İletişim',
  'blog.authorTeam': 'Top14 Ekibi',
  'blog.sources': 'Faydalı bağlantılar',
  'blog.breadcrumbHome': 'Ana sayfa',
};

export default tr;
